import { useState } from "react";
import "./App.css";

const services = [
  {
    number: "01",
    title: "Diseño que conecta",
    description:
      "Damos forma a tu identidad digital con experiencias intuitivas, cuidadas y hechas para tu audiencia.",
    icon: "✦",
  },
  {
    number: "02",
    title: "Desarrollo a medida",
    description:
      "Sitios rápidos, sólidos y adaptables. Tecnología que trabaja para tu negocio, no al revés.",
    icon: "⌘",
  },
  {
    number: "03",
    title: "E-commerce",
    description:
      "Transformamos tus productos en una experiencia de compra sencilla. De la primera visita al último clic.",
    icon: "◌",
  },
];

const projects = [
  {
    title: "Rutas Uruapan",
    category: "Plataforma web · Movilidad",
    image: "https://moss-and-meet.lovable.app/assets/case-rutas-Ay0Tmkry.jpg",
  },
  {
    title: "Sistema de inventarios",
    category: "Aplicación web · Gestión",
    image: "https://moss-and-meet.lovable.app/assets/case-inventarios-BzsQmZ40.jpg",
  },
  {
    title: "Tarjetas de fidelidad",
    category: "Aplicación web · Clientes",
    image: "https://moss-and-meet.lovable.app/assets/case-fidelidad-Du6Cbko6.jpg",
  },
];

const process = [
  ["01", "Escuchamos", "Conocemos tu negocio, tus objetivos y las personas con las que quieres conectar."],
  ["02", "Creamos", "Diseñamos y desarrollamos contigo. Cada decisión tiene una razón de ser."],
  ["03", "Lanzamos", "Cuidamos los detalles, probamos cada experiencia y damos el siguiente paso juntos."],
];

function Arrow() {
  return <span aria-hidden="true" className="text-2xl leading-none">↗</span>;
}

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="min-h-screen overflow-hidden bg-[#fbfcfa] text-[#3d514d]">
      <header className="site-header page-width flex h-[76px] items-center justify-between">
        <a href="#inicio" className="flex items-center gap-2 text-[18px] font-semibold tracking-[-0.03em]">
          <span className="grid h-7 w-7 place-items-center rounded-lg bg-[#b8f1df] text-xl">
            <img width="18" height="18" src="/logo192.png" alt="" />
          </span>
          Web-Link
        </a>
        <nav className="hidden items-center gap-8 text-sm md:flex" aria-label="Navegación principal">
          <a href="#servicios" className="hover:text-[#111c1a]">Servicios</a>
          <a href="#proyectos" className="hover:text-[#111c1a]">Proyectos</a>
          <a href="#proceso" className="hover:text-[#111c1a]">Proceso</a>
          <a href="#contacto" className="rounded-full bg-[#3d514d] px-5 py-3 text-white transition hover:bg-[#263b37]">Hablemos <Arrow /></a>
        </nav>
        <button
          type="button"
          className="rounded-full border border-[#3d514d]/20 px-4 py-2 text-sm md:hidden"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-expanded={menuOpen}
          aria-label="Abrir menú"
        >
          {menuOpen ? "Cerrar" : "Menú"}
        </button>
      </header>

      {menuOpen && (
        <nav className="mobile-menu page-width flex flex-col gap-4 border-t border-[#3d514d]/10 py-5 text-lg md:hidden" aria-label="Menú móvil">
          {["servicios", "proyectos", "proceso", "contacto"].map((item) => (
            <a key={item} href={`#${item}`} onClick={closeMenu} className="capitalize">{item}</a>
          ))}
        </nav>
      )}

      <main id="inicio">
        <section className="hero relative flex min-h-[min(650px,calc(100vh-76px))] items-end">
          <img
            src="https://moss-and-meet.lovable.app/assets/studio-forest-BYyf8S2L.jpg"
            alt="Estudio de diseño contemporáneo abierto a un bosque"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="hero-overlay absolute inset-0 bg-gradient-to-t from-[#101d1c]/85 via-[#101d1c]/25 to-transparent" />
          <div className="page-width relative z-10 pb-16 pt-24 text-[#f4f7f1] md:pb-24">
            <p className="eyebrow text-[#b8f1df]">ESTUDIO DE DISEÑO &amp; DESARROLLO WEB</p>
            <h1 className="mt-6 max-w-4xl font-display text-5xl font-medium leading-[.98] tracking-[-0.06em] md:text-8xl">
              Desarrollo web.<br />Ideas que toman<br />una nueva forma.
            </h1>
            <p className="mt-7 max-w-xl text-base leading-7 text-white/80 md:text-lg">
              Creamos experiencias digitales que se sienten bien y funcionan mejor. Tu visión, nuestro código. Un sitio que hace la diferencia.
            </p>
            <div className="mt-9 flex flex-wrap items-center gap-5">
              <a href="https://wa.me/3317370682?text=Hola%20Web-Link%2C%20me%20gustar%C3%ADa%20hablar%20sobre%20un%20proyecto%20web." className="inline-flex items-center gap-3 rounded-full bg-[#b8f1df] px-6 py-4 font-medium text-[#17302b] transition hover:bg-white">
                Construyamos tu proyecto <Arrow />
              </a>
              <a href="#proyectos" className="inline-flex items-center gap-2 px-2 py-3 text-white hover:text-[#b8f1df]">Explorar proyectos <Arrow /></a>
            </div>
          </div>
        </section>

        <section className="page-width grid gap-8 py-12 md:grid-cols-[1.4fr_1fr_1fr_1fr] md:items-center md:py-16">
          <p className="font-display text-2xl font-medium leading-tight md:text-3xl">Buenas ideas.<br />Mejores experiencias.</p>
          {["Diseño estratégico", "Código a medida", "Alto rendimiento"].map((item, index) => (
            <div key={item} className="flex items-center gap-3 text-sm">
              <span className="grid h-10 w-10 place-items-center rounded-full bg-[#b8f1df] text-xl">{["✦", "⌘", "↗"][index]}</span>
              {item}
            </div>
          ))}
        </section>

        <section id="servicios" className="page-width section-space">
          <div className="grid gap-8 md:grid-cols-[1fr_.8fr]">
            <div>
              <p className="eyebrow">01 / LO QUE HACEMOS</p>
              <h2 className="section-title mt-5">Todo lo que tu próxima gran idea necesita.</h2>
            </div>
            <p className="max-w-md leading-7">Unimos estrategia, creatividad y tecnología para construir sitios que no solo se ven bien: tienen un propósito.</p>
          </div>
          <div className="mt-14 grid gap-7 md:grid-cols-3">
            {services.map((service, index) => (
              <article
                key={service.number}
                className={`service-card min-h-[368px] rounded-lg border border-[#3d514d]/20 px-11 pb-10 pt-10 ${index === 1 ? "featured" : ""}`}
              >
                <div className="flex items-center justify-between text-3xl text-[#76cdb5]"><span>{service.icon}</span><span className="font-display text-sm text-[#3d514d]">{service.number}</span></div>
                <h3 className="mt-12 font-display text-2xl font-semibold">{service.title}</h3>
                <p className="mt-4 leading-7 text-[#60716d]">{service.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section id="proyectos" className="bg-[#f0f5f2]">
          <div className="page-width section-space">
            <div className="flex flex-wrap items-end justify-between gap-6">
              <div><p className="eyebrow">02 / CASOS DE ÉXITO</p><h2 className="section-title mt-5">Proyectos reales, en línea.</h2></div>
              <p>Sistemas que ya trabajan<br />para nuestros clientes</p>
            </div>
            <div className="mt-12 grid gap-5 md:grid-cols-3">
              {projects.map((project) => (
                <button key={project.title} type="button" onClick={() => setSelectedProject(project)} className="project-card group text-left">
                  <img src={project.image} alt={project.title} className="aspect-[1.15] w-full rounded-[2px] object-cover transition duration-500 group-hover:scale-[1.02]" />
                  <div className="flex items-start justify-between border-b border-[#3d514d]/20 py-5">
                    <div><h3 className="font-display text-xl font-medium">{project.title}</h3><p className="mt-1 text-sm text-[#60716d]">{project.category}</p></div>
                    <Arrow />
                  </div>
                </button>
              ))}
            </div>
          </div>
        </section>

        <section id="proceso" className="page-width section-space">
          <p className="eyebrow">03 / NUESTRO PROCESO</p>
          <h2 className="section-title mt-5 max-w-2xl">De una conversación a algo extraordinario.</h2>
          <div className="mt-14 grid gap-9 md:grid-cols-3">
            {process.map(([number, title, description]) => (
              <div key={number} className="process-step grid grid-cols-[48px_1fr] gap-4 border-t border-[#3d514d]/25 pt-5">
                <span className="font-display text-sm text-[#76cdb5]">{number}</span>
                <div><h3 className="font-display text-xl">{title}</h3><p className="mt-3 leading-7 text-[#60716d]">{description}</p></div>
              </div>
            ))}
          </div>
        </section>

        <section id="contacto" className="bg-[#b8f1df]">
          <div className="page-width flex min-h-[370px] flex-col justify-between gap-12 py-16 md:py-20">
            <div><p className="eyebrow text-[#3d514d]">EL SIGUIENTE PASO ES TUYO</p><h2 className="section-title mt-5 max-w-3xl">Tu próxima gran idea empieza aquí.</h2></div>
            <a href="https://wa.me/3317370682?text=Hola%20Web-Link%2C%20me%20gustar%C3%ADa%20hablar%20sobre%20un%20proyecto%20web." className="inline-flex w-fit items-center gap-3 text-lg font-medium hover:underline">Hablemos de tu proyecto <Arrow /></a>
          </div>
        </section>
      </main>

      <footer className="page-width flex flex-col gap-5 py-8 text-sm text-[#60716d] md:flex-row md:items-end md:justify-between">
        <div className="text-2xl font-semibold text-[#3d514d]"><span className="mr-2 inline-grid h-10 w-10 place-items-center rounded-xl bg-[#b8f1df]">
          <img width="16" height="16" src="https://img.icons8.com/tiny-glyph/16/code.png" alt="code"/>
          </span>Web-Link</div>
        <p>© 2026 Web-Link. Diseño con intención.</p>
        <p>Diseño &amp; desarrollo web</p>
      </footer>

      {selectedProject && (
        <div className="fixed inset-0 z-50 grid place-items-center bg-[#10201d]/80 p-5" role="dialog" aria-modal="true" aria-label={selectedProject.title} onClick={() => setSelectedProject(null)}>
          <div className="project-dialog max-w-3xl bg-[#fbfcfa] p-3" onClick={(event) => event.stopPropagation()}>
            <img src={selectedProject.image} alt={selectedProject.title} className="max-h-[70vh] w-full object-cover" />
            <div className="flex items-center justify-between gap-5 p-4"><div><h2 className="font-display text-2xl">{selectedProject.title}</h2><p className="text-sm text-[#60716d]">{selectedProject.category}</p></div><button type="button" onClick={() => setSelectedProject(null)} className="rounded-full border border-[#3d514d]/30 px-4 py-2 text-sm">Cerrar</button></div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
